import React, {Component} from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import copyToClipBoard from "copy-to-clipboard";

class ShareNow extends Component {
    state = {
        copied: false
    };

    _timeOutCopy = null;

    render() {
        const url = window.location.href;
        const {copied} = this.state;

        const text = copied ? <span>Copied!</span> : <span>Share now</span>;

        return (
            <div className="ShareNow text-center">
                <div className="Inner d-flex justify-content-center">
                    <input className="form-control" value={url} readOnly type="text"/>
                    <button
                        disabled={copied}
                        onClick={this._handleClickCopy}
                        className="btn btn-success">{text}
                    </button>
                </div>
            </div>
        );
    }

    _handleClickCopy = (e) => {
        e.preventDefault();

        this.setState({
            copied: true
        });

        const url = window.location.href;
        copyToClipBoard(url);

        if (this._timeOutCopy) {
            clearTimeout(this._timeOutCopy);
        }

        this._timeOutCopy = setTimeout(() => {
            this.setState({
                copied: false
            });
        }, 500);
    }
}

ShareNow.propTypes = {
    history: PropTypes.object.isRequired
};

export default withRouter(ShareNow);


// WEBPACK FOOTER //
// ./src/app/home/ShareNow.js